module.exports = __webpack_public_path__ + "static/media/agentAddressActive.ccd08a50.svg";